import React from 'react'
import "./Shimmer.css"

function Shimmer() {
  return (
    <div className='shimmer_wrapper'>
      <div className="shimmer dark"></div>
    </div>
  )
}

export default Shimmer
